import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { useRouter } from 'next/router';
import React from 'react';

import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import NextImageV2 from '../../../../ui/components/NextImageV2';
import {
  GA_FOOTER_APPSTORE,
  GA_FOOTER_PLAYSTORE,
} from '../../../core/constants/GAEventsConstants';
import { countryCodeFromLocaleForGa } from '../../../helpers/CountryHelpers';
import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import { getFooterAppDownloadLink } from '../../domain/helpers/FooterDownloadHelper';
import {
  DEFAULT_APP_STORE_IMAGE,
  DEFAULT_PLAY_STORE_IMAGE,
  DEFAULT_QR_IMAGE,
} from '../../domain/store/FooterStore';

interface FooterDownloadAppCmpProps {
  styles: { readonly [key: string]: string };
  isDesktop: boolean;
  footer_data?: FooterContentEntity;
}

function FooterDownloadAppCmp({
  styles,
  isDesktop,
  footer_data,
}: Readonly<FooterDownloadAppCmpProps>): React.ReactElement {
  const { category, city_selected } = useCitySelectedContext();
  const router = useRouter();
  const { locale } = router;

  const playstoreDownloadHandler = (): void => {
    publishGa4Events(
      category,
      GA_FOOTER_PLAYSTORE + countryCodeFromLocaleForGa(locale),
      city_selected,
    );
  };

  const appstoreDownloadHandler = (): void => {
    publishGa4Events(
      category,
      GA_FOOTER_APPSTORE + countryCodeFromLocaleForGa(locale),
      city_selected,
    );
  };

  const downloadLink = getFooterAppDownloadLink(
    router.asPath,
    city_selected,
    isDesktop,
    router.pathname,
  );

  return (
    <div className={styles['download']}>
      <div className={styles['qr-image']}>
        <NextImageV2
          src={
            footer_data ? footer_data.download_app_qr.path : DEFAULT_QR_IMAGE
          }
          alt="qr-download"
          height={146}
          width={146}
          quality={75}
        />
      </div>
      <div className={styles['download-android']}>
        <a href={downloadLink} onClick={playstoreDownloadHandler}>
          <NextImageV2
            src={
              footer_data
                ? footer_data.play_store_icon.path
                : DEFAULT_PLAY_STORE_IMAGE
            }
            alt="android-download"
            height={isDesktop ? 39 : 48}
            width={isDesktop ? 126 : 158}
            quality={75}
          />
        </a>
      </div>
      <div className={styles['download-iOS']}>
        <a href={downloadLink} onClick={appstoreDownloadHandler}>
          <NextImageV2
            src={
              footer_data
                ? footer_data.app_store_icon.path
                : DEFAULT_APP_STORE_IMAGE
            }
            alt="iOS-download"
            height={isDesktop ? 39 : 48}
            width={isDesktop ? 126 : 158}
            quality={75}
          />
        </a>
      </div>
    </div>
  );
}

export default FooterDownloadAppCmp;
